import React, { ChangeEvent, MouseEvent, useState } from "react";

import { useSelector } from "react-redux";

import Sheet from "../../comps/sheet/Sheet";
import SheetHead from "../../comps/sheet/SheetHead";
import SheetHeadTitle from "../../comps/sheet/SheetHeadTitle";
import SheetBody from "../../comps/sheet/SheetBody";
import SheetFooter from "../../comps/sheet/SheetFooter";
import TextField from "../../comps/textfield/TextField";
import {
  Typography,
  Grid,
  Button,
  makeStyles,
  ListSubheader,
  MenuItem,
  Avatar,
  ListItemAvatar,
  ListItemText,
  Menu,
} from "@material-ui/core";
import {
  WebsocketProps,
  wsContext,
} from "../../config/websocket/WebsocketProvider";
import SheetSection from "../../comps/sheet/SheetSection";
// import { useDocumentData } from "react-firebase-hooks/firestore";
// import { projectFirestore as db } from "../../config/firebase/config";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import InfoIcon from "@material-ui/icons/Info";
import PowerOutlinedIcon from "@material-ui/icons/PowerOutlined";
import RadioButton from "../../comps/radiobutton/RadioButton";
import RadioButtonContainer from "../../comps/radiobutton/RadioButtonContainer";
import {
  Live,
  LowerThirdsInterface,
  LowerThirdsIngame,
  LowerThirdsMode,
  MessageItem,
  Participant,
  PollItemProps,
  ReduxState,
} from "../../config/types/types";
import fbase, { projectFirestore as db } from "../../config/firebase/config";
import { useCollection, useDocumentData } from "react-firebase-hooks/firestore";
import AdDialog from "../../comps/dialogs/AdDialog";
import { AdProps } from "../../config/types/ads.interface";
import blobber from "@utils/blobber";
import useSettings from "@lib/useSettings";

const ms = makeStyles((theme) => ({
  accordionHead: {},

  accordionHeadExpanded: {
    // minHeight: "auto!important",
    // margin: 0 + "!important",
  },
  select: {
    maxHeight: 300,
    // width: 200,
  },
  listsubheader: {
    backgroundColor: "#9c27b0",
    color: "#fff",
  },
  featuredPlayer: {
    display: "flex",
    flexDirection: "column",

    "& .selected": {
      display: "flex",
      alignItems: "center",
      "& .teamLogo, .playerPhoto": {
        height: 100,
        width: 100,
        borderRadius: 3,
        border: "1px solid rgba(0,0,0,.1)",
        backgroundSize: "contain",
        // backgroundPosition: "bottom center",
        backgroundRepeat: "no-repeat",
        marginRight: theme.spacing(2),
      },

      "& .teamLogo": { backgroundPosition: "center" },
      "& .playerPhoto": { backgroundPosition: "bottom center" },
    },
  },
  shoutout: {
    display: "flex",
    alignItems: "center",
    padding: "5px 10px",
    marginBottom: 10,
    width: "100%",
    border: "1px solid rgba(0,0,0,.2)",
    transition: "all .15s ease-out",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,.1)",
    },
    "& .logo": {
      height: 75,
      width: 75,
      marginRight: 10,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
    },
    "& .content": {
      display: "flex",
      flexDirection: "column",

      "& .alias": { fontWeight: "bold" },
    },
  },
  ad: {
    display: "flex",
    alignItems: "center",
    padding: "5px 10px",
    marginBottom: 10,
    width: "100%",
    border: "1px solid rgba(0,0,0,.2)",
    transition: "all .15s ease-out",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,.1)",
    },
    "& .img": {
      height: 75,
      width: 75,
      marginRight: 10,
      backgroundSize: "contain",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
    },
    "& .body": {
      display: "flex",
      flexDirection: "column",

      "& .head": { fontWeight: "bold" },
    },
  },
}));

const SelectionItems = (
  participants: Participant[],
  form: LowerThirdsInterface,
  ws: WebsocketProps,
  onClose: () => void
) => {
  const classes = ms();
  let list: any[] = [];
  participants
    .filter((team) => Boolean(team?.players?.length))
    .forEach((team) => {
      list = [
        ...list,
        <ListSubheader key={team.id} className={classes.listsubheader}>
          {team.display_name}
        </ListSubheader>,
      ];

      team.players?.forEach((p) => {
        list = [
          ...list,
          <MenuItem
            button
            dense
            key={p.ign}
            onClick={() => {
              ws.setLiveSettings({
                lowerThirdsIngame: { ...form, player: { ...p, team } },
              } as Partial<Live>);
              onClose();
            }}
          >
            <ListItemAvatar>
              <Avatar src={p.photo_main} />
            </ListItemAvatar>
            <ListItemText>{p.ign}</ListItemText>
          </MenuItem>,
        ];
      });
    });
  return list;
};

const IngameLT = () => {
  const classes = ms();
  const [anchorEl, setAnchorEl] = React.useState<any>(null);

  const [adState, setAdState] = useState<{
    open: boolean;
    docSnap: fbase.firestore.DocumentSnapshot | null;
  }>({ open: false, docSnap: null });

  const [form, setForm] = React.useState<LowerThirdsIngame>({
    is_live: false,
    headline: "",
    ticker: "",
    announcement_headline: "",
    announcement_headline_font_size: 0,
    announcement_content_font_size: 0,
    announcement_content: "",
    mode: "casters",
    live: false,
    player: undefined,
    player_stats: {
      left: {
        property: "Header 1",
        value: "Stat 1",
      },
      middle: {
        property: "Header 2",
        value: "Stat 2",
      },
      right: {
        property: "Header 3",
        value: "Stat 3",
      },
    },
    player_quote: "",
  });
  const ws = React.useContext(wsContext);
  const { preloadImages } = useSettings();

  const live = useSelector((state: ReduxState) => state.live);
  const { lowerThirdsIngame: lowerThirds, tournament, match } = live;
  const [pickem] = useDocumentData<PollItemProps>(
    db
      .collection("tournaments")
      .doc(tournament?.url)
      .collection("poll")
      .doc(match?.id + "")
  );

  const [ads]: [fbase.firestore.QuerySnapshot, boolean, any] = useCollection(
    db
      .collection("tournaments")
      .doc(tournament?.url ?? "")
      .collection("ads")
  );

  React.useEffect(() => {
    if (!lowerThirds) return;
    if (form === lowerThirds) return;
    setForm(lowerThirds);
  }, [lowerThirds, setForm]);

  const apply = (e: any): void => {
    ws.setLiveSettings({
      lowerThirdsIngame: form,
    } as Partial<Live>);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.currentTarget.name]: e.currentTarget.value });
  };

  // const toggleLowerThirds = () => {
  //   ws.setLiveSettings({
  //     lowerThirdsIngame: { ...form, live: !form.live },
  //   } as Partial<Live>);
  // };

  const selectMode = (mode: LowerThirdsMode) => () => {
    ws.setLiveSettings({
      lowerThirdsIngame: { ...form, mode: mode },
    } as Partial<Live>);
  };

  const toggleSwitch = () => {
    ws.setLiveSettings({
      lowerThirdsIngame: { ...form, is_live: !form.is_live },
    } as Partial<Live>);
  };

  const onAdClick =
    (ad: fbase.firestore.DocumentSnapshot) => async (e: MouseEvent) => {
      if (e.ctrlKey) {
        setAdState({ open: true, docSnap: ad });
      } else {
        let newAd = ad.data() as AdProps;
        if (preloadImages) {
          newAd = {
            ...newAd,
            img: {
              ...newAd.img,
              url: (await blobber(newAd.img?.url ?? "")) ?? "",
            },
          };
        }
        ws.setLiveSettings({
          lowerThirdsIngame: { ...form, ad: newAd },
        } as Partial<Live>);
      }
    };

  return (
    <Sheet style={{ border: "1px solid #8e24aa" }}>
      <SheetHead color="violet">
        <SheetHeadTitle>Lower Thirds</SheetHeadTitle>
        {/* <SheetHeadSub>Subtitle</SheetHeadSub> */}
      </SheetHead>
      <SheetBody>
        {/* Control */}
        <SheetSection>
          <Typography variant="h4">Switch</Typography>
          <RadioButton
            checked={form.is_live}
            onClick={toggleSwitch}
            label="Show/Hide"
          />
        </SheetSection>

        {/* Actions */}
        <SheetSection style={{ border: "1px solid rgba(0,0,0,.4)" }}>
          <Typography variant="h4">Mode</Typography>
          <RadioButtonContainer>
            <RadioButton
              checked={form.mode === "ticker"}
              label="Ticker"
              onClick={selectMode("ticker")}
            />
            <RadioButton
              checked={form.mode === "casters"}
              label="Caster"
              onClick={selectMode("casters")}
            />
            <RadioButton
              checked={form.mode === "long"}
              label="Long Headline"
              onClick={selectMode("long")}
            />
            <RadioButton
              checked={form.mode === "playerStats"}
              label="Player Stats"
              disabled={!Boolean(form.player)}
              onClick={selectMode("playerStats")}
            />
            <RadioButton
              checked={form.mode === "playerQuote"}
              label="Player Quote"
              disabled={!Boolean(form.player)}
              onClick={selectMode("playerQuote")}
            />
            <RadioButton
              checked={form.mode === "veto"}
              label="Veto"
              disabled={!Boolean(match?.veto?.length)}
              onClick={selectMode("veto")}
            />
            <RadioButton
              checked={form.mode === "pickem"}
              label="PickEm"
              disabled={!pickem}
              onClick={selectMode("pickem")}
            />
            <RadioButton
              checked={form.mode === "pickemShoutout"}
              label="PickEm Shoutout"
              disabled={!pickem}
              onClick={selectMode("pickemShoutout")}
            />
            <RadioButton
              checked={form.mode === "ad"}
              label="Ad"
              onClick={selectMode("ad")}
            />
            <RadioButton
              checked={form.mode === "adSmall"}
              label="Ad Small"
              onClick={selectMode("adSmall")}
            />
          </RadioButtonContainer>
        </SheetSection>

        {/* Player */}
        <SheetSection style={{ padding: 0 }}>
          <Accordion style={{ padding: "5px 10px", boxShadow: "none" }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h4">Featured Player</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                {/* Headline */}
                <Grid item xs={12}>
                  <Button
                    onClick={({ currentTarget }) => setAnchorEl(currentTarget)}
                    variant="contained"
                    color="primary"
                  >
                    Select Player
                  </Button>
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => setAnchorEl(null)}
                    classes={{ paper: classes.select }}
                  >
                    {SelectionItems(
                      tournament?.participants ?? [],
                      form,
                      ws,
                      () => setAnchorEl(null)
                    ).map((item: any) => item)}
                  </Menu>
                </Grid>

                <Grid item xs={12} className={classes.featuredPlayer}>
                  <div className="selected">
                    <div
                      className="teamLogo"
                      style={{
                        backgroundImage: `url("${form.player?.team?.logo}")`,
                      }}
                    ></div>
                    <div
                      className="playerPhoto"
                      style={{
                        backgroundImage: `url("${form.player?.photo_main}")`,
                      }}
                    ></div>
                    <div className="text">
                      <Typography className="ign">
                        {form.player?.ign}
                      </Typography>
                      <Typography className="name">
                        {form.player?.name}
                      </Typography>
                    </div>
                  </div>
                </Grid>

                {/* Stats and Quote */}
                <Grid item xs={12} className={classes.featuredPlayer}>
                  <TextField
                    value={form.player_quote}
                    name="player_quote"
                    onChange={handleChange}
                    label="Quote"
                    size="small"
                  />
                </Grid>
                <Grid item xs={6} className={classes.featuredPlayer}>
                  <TextField
                    value={form.player_stats?.left?.property}
                    name="property"
                    onChange={({ currentTarget: { name, value } }) =>
                      setForm({
                        ...form,
                        player_stats: {
                          ...form.player_stats,
                          left: { ...form.player_stats?.left, [name]: value },
                        },
                      })
                    }
                    label="Heading 1"
                    size="small"
                  />
                </Grid>
                <Grid item xs={6} className={classes.featuredPlayer}>
                  <TextField
                    value={form.player_stats?.left?.value}
                    name="value"
                    onChange={({ currentTarget: { name, value } }) =>
                      setForm({
                        ...form,
                        player_stats: {
                          ...form.player_stats,
                          left: { ...form.player_stats?.left, [name]: value },
                        },
                      })
                    }
                    label="Stat 1"
                    size="small"
                  />
                </Grid>
                <Grid item xs={6} className={classes.featuredPlayer}>
                  <TextField
                    value={form.player_stats?.middle?.property}
                    name="property"
                    onChange={({ currentTarget: { name, value } }) =>
                      setForm({
                        ...form,
                        player_stats: {
                          ...form.player_stats,
                          middle: {
                            ...form.player_stats?.middle,
                            [name]: value,
                          },
                        },
                      })
                    }
                    label="Heading 1"
                    size="small"
                  />
                </Grid>
                <Grid item xs={6} className={classes.featuredPlayer}>
                  <TextField
                    value={form.player_stats?.middle?.value}
                    name="value"
                    onChange={({ currentTarget: { name, value } }) =>
                      setForm({
                        ...form,
                        player_stats: {
                          ...form.player_stats,
                          middle: {
                            ...form.player_stats?.middle,
                            [name]: value,
                          },
                        },
                      })
                    }
                    label="Stat 1"
                    size="small"
                  />
                </Grid>
                <Grid item xs={6} className={classes.featuredPlayer}>
                  <TextField
                    value={form.player_stats?.right?.property}
                    name="property"
                    onChange={({ currentTarget: { name, value } }) =>
                      setForm({
                        ...form,
                        player_stats: {
                          ...form.player_stats,
                          right: {
                            ...form.player_stats?.right,
                            [name]: value,
                          },
                        },
                      })
                    }
                    label="Heading 1"
                    size="small"
                  />
                </Grid>
                <Grid item xs={6} className={classes.featuredPlayer}>
                  <TextField
                    value={form.player_stats?.right?.value}
                    name="value"
                    onChange={({ currentTarget: { name, value } }) =>
                      setForm({
                        ...form,
                        player_stats: {
                          ...form.player_stats,
                          right: {
                            ...form.player_stats?.right,
                            [name]: value,
                          },
                        },
                      })
                    }
                    label="Stat 1"
                    size="small"
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </SheetSection>

        {/* Shoutout */}
        <SheetSection style={{ padding: 0 }}>
          <Accordion style={{ padding: "5px 10px", boxShadow: "none" }}>
            <AccordionSummary
              className={classes.accordionHead}
              classes={{ expanded: classes.accordionHeadExpanded }}
              expandIcon={<ExpandMoreIcon />}
            >
              <Typography variant="h4">Shoutout</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                {/* Headline */}

                {pickem?.votes
                  .filter((v) => Boolean(v.message))
                  .map((v, i) => (
                    <div
                      className={classes.shoutout}
                      key={i}
                      style={{
                        backgroundColor:
                          v.message !== false &&
                          form?.shoutout?.message === v.message?.message &&
                          form?.shoutout?.alias === v.message?.alias &&
                          form?.shoutout?.img === v.message?.img
                            ? "rgba(0,0,0,.3)"
                            : "transparent",
                      }}
                      onClick={() =>
                        ws.setLiveSettings({
                          lowerThirdsIngame: {
                            ...lowerThirds,
                            shoutout: v.message as MessageItem,
                          },
                        } as Live)
                      }
                    >
                      <div
                        className="logo"
                        style={{
                          backgroundImage: `url(${
                            v.message !== false && v.message?.img
                          })`,
                        }}
                      ></div>
                      <div className="content">
                        <div className="alias">
                          {v.message !== false && v.message?.alias}
                        </div>
                        <div className="message">
                          {v.message !== false && v.message?.message}
                        </div>
                      </div>
                    </div>
                  ))}
                <Grid item xs={12}></Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </SheetSection>

        {/* Ads */}
        <SheetSection style={{ padding: 0, paddingBottom: 5 }}>
          <Accordion style={{ padding: "5px 10px", boxShadow: "none" }}>
            <AccordionSummary
              className={classes.accordionHead}
              classes={{ expanded: classes.accordionHeadExpanded }}
              expandIcon={<ExpandMoreIcon />}
            >
              <Typography variant="h4">Ads</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                <Grid item xs={12} style={{ marginBottom: 10 }}>
                  <Button
                    variant="outlined"
                    onClick={() => setAdState({ open: true, docSnap: null })}
                  >
                    Create Ad
                  </Button>
                </Grid>
                {ads?.docs?.map((doc) => {
                  let data: AdProps = doc.data() as AdProps;
                  return (
                    <Grid
                      item
                      xs={12}
                      className={classes.ad}
                      onClick={onAdClick(doc)}
                      style={{
                        backgroundColor:
                          data.head?.text === lowerThirds?.ad?.head?.text &&
                          data.content?.text === lowerThirds?.ad?.content?.text
                            ? "rgba(0,0,0,.3)"
                            : "transparent",
                      }}
                    >
                      <div
                        className="img"
                        style={{ backgroundImage: `url("${data.img?.url}")` }}
                      ></div>
                      <div className="body">
                        <div className="head">{data.head?.text}</div>
                        <div>{data.content?.text}</div>
                      </div>
                    </Grid>
                  );
                })}
              </Grid>
            </AccordionDetails>
          </Accordion>
          <SheetFooter>
            <InfoIcon /> Ctrl + Click to edit
          </SheetFooter>
        </SheetSection>

        {/* Ticker */}
        <SheetSection style={{ padding: 0 }}>
          <Accordion style={{ padding: "5px 10px", boxShadow: "none" }}>
            <AccordionSummary
              className={classes.accordionHead}
              classes={{ expanded: classes.accordionHeadExpanded }}
              expandIcon={<ExpandMoreIcon />}
            >
              <Typography variant="h4">Ticker</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                {/* Headline */}
                <Grid item xs={12}>
                  <TextField
                    onChange={handleChange}
                    label="Headline"
                    name="headline"
                    value={form.headline}
                    fullWidth
                    size="small"
                  />
                </Grid>

                {/* Ticker */}
                <Grid item xs={12}>
                  <TextField
                    size="small"
                    onChange={handleChange}
                    label="Ticker"
                    name="ticker"
                    multiline
                    value={form.ticker}
                    rows={1}
                    rowsMax={5}
                    fullWidth
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </SheetSection>

        {/* Announcements */}
        <SheetSection style={{ padding: 0 }}>
          <Accordion style={{ padding: "5px 10px", boxShadow: "none" }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h4">Long Headline</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                {/* Headline */}
                <Grid item xs={12}>
                  <TextField
                    onChange={handleChange}
                    label="Headline"
                    name="announcement_headline"
                    value={form.announcement_headline}
                    fullWidth
                    size="small"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    onChange={(e: ChangeEvent<HTMLInputElement>) =>
                      setForm({
                        ...form,
                        [e.target.name]: e.target.valueAsNumber,
                      })
                    }
                    label="Headline font size"
                    name="announcement_headline_font_size"
                    value={form.announcement_headline_font_size}
                    size="small"
                    type="number"
                  />
                </Grid>

                {/* Ticker */}
                <Grid item xs={12}>
                  <TextField
                    size="small"
                    onChange={handleChange}
                    label="Content"
                    name="announcement_content"
                    multiline
                    value={form.announcement_content}
                    rows={1}
                    rowsMax={5}
                    fullWidth
                    inputProps={{ min: 1 }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    onChange={(e: ChangeEvent<HTMLInputElement>) =>
                      setForm({
                        ...form,
                        [e.target.name]: e.target.valueAsNumber,
                      })
                    }
                    label="Content font size"
                    name="announcement_content_font_size"
                    value={form.announcement_content_font_size}
                    size="small"
                    type="number"
                    inputProps={{ min: 1 }}
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </SheetSection>

        <Button
          fullWidth
          variant="contained"
          style={{ marginTop: 10 }}
          disabled={
            form.headline === lowerThirds?.headline &&
            form.ticker === lowerThirds?.ticker &&
            form.announcement_headline === lowerThirds?.announcement_headline &&
            form.announcement_headline_font_size ===
              lowerThirds?.announcement_headline_font_size &&
            form.announcement_content === lowerThirds?.announcement_content &&
            form.announcement_content_font_size ===
              lowerThirds?.announcement_content_font_size &&
            form.player_stats === lowerThirds?.player_stats &&
            form.player_quote === lowerThirds?.player_quote
          }
          onClick={apply}
          color="primary"
        >
          Apply Changes
        </Button>
      </SheetBody>

      <SheetFooter>
        <PowerOutlinedIcon />
        Websocket only. Not Saved Online.
      </SheetFooter>

      <AdDialog
        {...adState}
        onClose={() => setAdState({ open: false, docSnap: null })}
      />
    </Sheet>
  );
};

export default IngameLT;
